import { DependenciesInjection } from "app/di/DependencyInjection";
import { ErrorCodeManagementImpl } from "../data/ErrorCodeManagementImpl";
import { IErrorCodeManagementRepository } from "../domain/repositories/IErrorCodeManagementRepository";
import { ErrorCodeManagementUseCase } from "../domain/useCases/ErrorCodeManagementUseCase";
import { ErrorCodeManagementViewModel } from "../presentation/viewModel/ErrorCodeManagementViewModel";
import { ErrorCodeManagementToken } from "./ErrorCodeManagementToken";

export class ErrorCodeManagementInjection {
  static initInjection() {
    DependenciesInjection.register<IErrorCodeManagementRepository>(
      ErrorCodeManagementToken.IErrorCodeManagementRepository,
      ErrorCodeManagementImpl,
      "otherRepo",
    );
    DependenciesInjection.register<ErrorCodeManagementUseCase>(
      ErrorCodeManagementToken.ErrorCodeManagementUseCase,
      ErrorCodeManagementUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<ErrorCodeManagementViewModel>(
      ErrorCodeManagementToken.ErrorCodeManagementViewModel,
      ErrorCodeManagementViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IErrorCodeManagementRepository>(
      ErrorCodeManagementToken.IErrorCodeManagementRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<ErrorCodeManagementUseCase>(
      ErrorCodeManagementToken.ErrorCodeManagementUseCase,
    );
  }
}
